// components/Countdown.tsx
import React, { useEffect, useState } from "react";
import logger from "../utils/logger";
import "./Countdown.scss";

interface CountdownProps {
  onComplete?: () => void;
  showCountdown?: boolean;
}

const Countdown: React.FC<CountdownProps> = ({ onComplete, showCountdown }) => {
  const [count, setCount] = useState(3);

  useEffect(() => {
    if (!showCountdown) {
      setCount(3);
      return;
    }

    if (count <= 0) {
      if (onComplete) onComplete();
      return;
    }

    const timer = setTimeout(() => {
      setCount((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [count, showCountdown]);

  if (!showCountdown || count <= 0) {
    return null;
  }

  logger.info(`⏱️ Rendering countdown overlay with count: ${count}`);

  return (
    <div className="countdown-overlay" data-countdown="true">
      <div className="countdown-content">
        <div className="countdown-number">{count}</div>
        <div className="countdown-text">Get Ready...</div>
      </div>
    </div>
  );
};

export default Countdown;
